<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-date-picker v-model="searchFrom.kq_time" format="YYYY-MM-DD" />
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.campus_id" mode="multiple" placeholder="校区" style="width: 150px;" allow-clear>
              <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.grade_id" mode="multiple"  placeholder="年级" style="width: 100px;" allow-clear>
              <a-select-option v-for="(item) in nianjiList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.is_kq" placeholder="是否考勤" style="width: 100px;" allow-clear>
              <a-select-option :key="0" value="0">已考勤</a-select-option>
              <a-select-option :key="1" value="1">未考勤</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.type" mode="multiple" placeholder="班型" style="width: 120px;" allow-clear>
              <a-select-option :key="0" :value="0">培优班</a-select-option>
              <a-select-option :key="1" :value="1">提高班</a-select-option>
              <a-select-option :key="2" :value="2">英才班</a-select-option>
              <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
              <a-select-option :key="4" :value="4">体验课</a-select-option>
			    <a-select-option :key="5" :value="5">冲刺班</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.phase" placeholder="考勤阶段" style="width: 100px;" allow-clear>
              <a-select-option :key="1" value="1">第1阶段</a-select-option>
              <a-select-option :key="2" value="2">第2阶段</a-select-option>
              <a-select-option :key="3" value="3">第3阶段</a-select-option>
              <a-select-option :key="4" value="4">第4阶段</a-select-option>
              <a-select-option :key="5" value="5">第5阶段</a-select-option>
              <a-select-option :key="6" value="6">上午</a-select-option>
              <a-select-option :key="7" value="7">下午</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.interval" placeholder="考勤时间" style="width: 100px;" allow-clear>
              <a-select-option :key="4" value="4">周五段</a-select-option>
              <a-select-option :key="1" value="1">周六段</a-select-option>
              <a-select-option :key="2" value="2">周日段</a-select-option>
              <a-select-option :key="3" value="3">每天段</a-select-option>
              <a-select-option :key="0" value="0">全部</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" @click="tableSearch">查询数据</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="dashed" style="margin-left: 20px;" @click="creataTable" :loading="loading">生成报表</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="dashed" style="margin-left: 20px;" @click="exports" :loading="loading">导出数据</a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>

      <h4>总班级数：{{ data.length }}</h4>

    </div>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading" bordered>
        <a-table-column key="is_kq" title="状态">
          <template slot-scope="item">
            <a-tag v-if="item.is_kq === 1" color="#f50">
              未考勤
            </a-tag>
            <a-tag v-if="item.is_kq === 0" color="#2db7f5">
              已考勤
            </a-tag>
          </template>
        </a-table-column>
		  <a-table-column key="subject" title="学科" data-index="subject" />
        <a-table-column key="campusname" title="校区" data-index="campusname" />
        <a-table-column key="grade" title="年级" data-index="gradename" />
        <a-table-column key="name" title="班级" data-index="squad_name" />
        <a-table-column key="semester_name" title="季度" data-index="semester_name" />
        <a-table-column key="y_count" title="应到" data-index="y_count" />
        <a-table-column key="s_count" title="实到" data-index="s_count" />
        <a-table-column key="tk_count" title="调课" data-index="tk_count" />
        <a-table-column key="qj_count" title="请假" data-index="qj_count" />
        <a-table-column key="qx_count" title="缺席" data-index="qx_count" />
        <a-table-column key="teacher" title="老师" data-index="teacher" />
        <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
        <a-table-column key="phase" title="阶段" data-index="phase" />
        <a-table-column key="start_create_time" title="时间" data-index="start_create_time" width="220px" />
        <a-table-column key="remarks" title="备注" data-index="remarks" width="220px" />
        <a-table-column key="del" width="180px" title="操作">
          <template slot-scope="item">
            <showGradeAttendance v-if="item.is_kq === 0" :kq_time="item.kq_time" :squad_id="item.squad_id" />
          </template>
        </a-table-column>
      </a-table>
    </div>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import moment from "moment";
import showGradeAttendance from "../components/show_grade_attendance.vue";
export default {
  components: { AFormItem, showGradeAttendance },
  data() {
    return {
      data: [],
      courseChapterVisible: false,
      pageinfo: { total: 1, current: 1, pageSize: 9999 },
      loading: false,
      visible: false,
      bindVisible: false,
      nianjiList: [],
      courseList: [],
      courseTeacherList: [],
      searchFrom: {
        campus_id: undefined,
        kq_time: undefined,
        grade_id: undefined,
        exports: 0,
        type: undefined,
        is_kq: undefined,
        phase: undefined,
        interval: undefined,
      },
      courseChapterList: [],
      campusList: [],
      form: {
        id: undefined,
        name: undefined,
        course_id: undefined,
        grade_id: undefined,
        admin_id: undefined,
        instructor: undefined,
        amount: undefined,
        type: undefined
      },
      gradeList: []
    };
  },
  mounted() {
    this.getCampusList();
    this.getGradeList();
    this.getNianjiList();
  },
  methods: {
    changeFormCampus(campus_id) {
      this.getCourseTeacherList({ campus_id: campus_id });
    },
    getGradeList() {
      this.$axios
        .post("/api/BasicGrade/index")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.gradeList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    getNianjiList() {
      this.$axios
        .post("/api/BasicGrade/index", {
          pageinfo: {
            pageSize: 999
          }
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.nianjiList = res.data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCourseList() {
      this.$axios
        .post("/api/BasicCourse/index", { pageinfo: { pageSize: 9999 } })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.courseList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampusList() {
      this.$axios
        .post("/api/Admin/getorgsquadlist")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusList = res.data.org_campus;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    tableSearch() {
      this.searchFrom.kq_time = moment(this.searchFrom.kq_time).format('YYYY-MM-DD');
      this.searchFrom.exports = 0;
      this.getTableList(this.searchFrom);
    },
    exports() {

      this.searchFrom.kq_time = moment(this.searchFrom.kq_time).format('YYYY-MM-DD');
      this.searchFrom.exports = 1;
      this.getTableList(this.searchFrom);
    },

    creataTable() {
      this.searchFrom.kq_time = moment(this.searchFrom.kq_time).format('YYYY-MM-DD');
      this.loading = true;
      this.$axios
        .post("/api/Attendance/createAllSquadAtten", {
          data: {
            kq_time: this.searchFrom.kq_time,
          },
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList(this.searchFrom);
          }
        })
        .catch(err => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
    },
    getTableList(data) {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(data));
      if(data.type){
        params.type = params.type.join(',');
      }
      if(data.campus_id){
        params.campus_id = params.campus_id.join(',');
      }
      this.$axios
        .post("/api/Attendance/getAllSquadAtten", {
          data:params
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            if (data.exports != 1) {
              this.data = res.data;
            }
            else {
              window.open(res.data);
            }
          }
        })
        .catch(err => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
    },
  },
  moment,
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>